import { connect } from 'react-redux';
import { paramsByJobIds } from './../reducers';
import JobParamsInfoComponent
  from './../Components/JobParamsInfoComponent.jsx';

export const mapStateToProps = (state) => {
  return { paramsByIds: paramsByJobIds(state) };
};

export default connect(
  mapStateToProps
)(JobParamsInfoComponent);


// WEBPACK FOOTER //
// src/Containers/JobParamsInfoContainer.jsx